import { render } from "./WangBaoMenPage.vue?vue&type=template&id=fdfb952a&scoped=true"
import script from "./WangBaoMenPage.vue?vue&type=script&lang=js"
export * from "./WangBaoMenPage.vue?vue&type=script&lang=js"

import "./WangBaoMenPage.vue?vue&type=style&index=0&id=fdfb952a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfb952a"]])

export default __exports__